import React from 'react';
import { UserContext, IUser } from './components/user_context_provider';

enum ExpValues {
  Experiment = 'experiment',
  Default = 'default',

  // multivariate default
  Ctl = 'ctl',
}

// "Caches" any call to useExpEnabled where the experiment was not found
// in the config and was then defaulted during the render cycle. This
// allows us to discover experiments that are present on the page,
// but not yet in a user's local config
export const unknownExps = {};

// useUser will inject the current user via a React Hook
export function useUser(): Partial<IUser> {
  return React.useContext(UserContext);
}

// Record an unfound experiment
export function recordUnknownExp(name) {
  unknownExps[name] = ExpValues.Default;
}

// useExpName takes the name for any given experiment and returns
// the value for the current user. With this React Hook you do not
// need to wrap your component in the withUserContext() HOC
export function useExpEnabled(name: string) {
  const user = useUser();
  return inExperiment(user, name);
}

export function inExperiment(user: Partial<IUser>, name: string) {
  const experiments = user.experiments ?? [];
  let val = experiments.find(x => x.name === name)?.value;
  if (!val) {
    val = ExpValues.Default;
    recordUnknownExp(name);
  }

  return val === ExpValues.Experiment;
}
